// extracted by mini-css-extract-plugin
export default {"overlayImagesContainer":"WP-z","loadingMedia":"XP-z","reviewsImagesAndVideos":"YP-z","limitHeight":"ZP-z"};